module.exports = __webpack_public_path__ + "img/20180815_154807_249.98674286.jpg";